import TableRow from '@mui/material/TableRow';
import { CheckBoxInput } from '../../style';
import CellsRow from './CellsRow';
import { IDebts, IMandatoryDebt } from '../../../../hooks/useDebts';
import TableTooltip from '../../../../components/TableTooltip';
import { differenceInDays } from 'date-fns';

interface IConfigureTableRowProps {
  data: any;
  configuredColumns: any[];
  setIsChecked: (bool: boolean | any) => void;
  isChecked: { [key: string]: boolean };
  handleRowAction?: (item: any) => any;
  setMandatoryDebts?: (item: IMandatoryDebt[]) => void;
}

export default function ConfiguredTableRow({
  data,
  configuredColumns,
  setIsChecked,
  isChecked,
  handleRowAction,
  setMandatoryDebts,
}: IConfigureTableRowProps) {
  return (
    <>
      {data &&
        data?.results?.map((each: IDebts) => {
          const totalDebts =
            Number(each?.price ?? 0) + Number(each?.totalMandatory ?? 0);
          const eachPriceDebts = Number(each?.price ?? 0);
          const eachMandatoryDebts = Number(each?.totalMandatory ?? 0);

          //TODO: quatro dias pro vencimento = A pagar
          // Mais que quatro dia do vencimento = pendente
          // Atrasdao = atrasado
          // const dueDate: Date = new Date(each?.dueDate);
          // const diffTime = Math.abs((dueDate as any) - (new Date() as any));
          // const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          const currentDate = new Date();
          const dueDate = new Date(each?.dueDate);

          const status = dueDate < currentDate ? 'Atrasado' : 'A pagar';

          const tableCells = [
            {
              id: `item-0`,
              value: each?.vehiclePlate ?? '--',
            },
            {
              id: `item-1`,
              value: each?.vehicleUF ?? '--',
              className: 'uf-column',
            },
            {
              id: `item-2`,
              value: each?.type.toUpperCase() ?? '--',
            },
            {
              id: `item-3`,
              value: (
                <TableTooltip
                  text={
                    each?.description +
                    (each?.additionalDescription
                      ? ' - ' + each?.additionalDescription
                      : '') || '--'
                  }
                  tooltipText={
                    each?.description +
                    (each?.additionalDescription
                      ? ' - ' + each?.additionalDescription
                      : '') || '--'
                  }
                  className='description-text'
                />
              ),
              style: {
                display: '-webkit-box',
                minHeight: '48px',
              },
            },
            {
              id: `item-4`,
              value:
                eachPriceDebts > 0
                  ? `R$ ${eachPriceDebts.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                  : '--',
            },
            {
              id: `item-5`,
              value:
                eachMandatoryDebts > 0 ? (
                  <span
                    style={{
                      color: '#F58220',
                      fontWeight: 700,
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      fontSize: '14px',
                    }}
                    onClick={() => {
                      if (setMandatoryDebts)
                        setMandatoryDebts(each?.onCheck?.select);
                      if (handleRowAction) handleRowAction(true);
                    }}
                  >
                    {`R$ ${eachMandatoryDebts.toLocaleString('pt-BR', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`}
                  </span>
                ) : (
                  '--'
                ),
            },
            {
              id: `item-6`,
              value:
                totalDebts > 0
                  ? `R$ ${totalDebts.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`
                  : '--',
            },
            {
              id: `item-7`,
              value: each?.driverName ?
                <TableTooltip
                  text={each?.driverName}
                  tooltipText={each?.driverName}
                /> 
                : "--",
                style: {
                  display: '-webkit-box',
                  minHeight: '48px',
                },
            },
            {
              id: `item-8`,
              value: status,
              style: {
                color:
                  status === 'Atrasado'
                    ? '#FC0027'
                    : status === 'A pagar'
                      ? '#EDB903'
                      : '#008000',
                fontWeight: 700,
              },
            },
            {
              id: `item-9`,
              value: each?.consultDate
                ? `${new Date(
                  each?.consultDate,
                )?.toLocaleDateString()} - ${new Date(
                  each?.consultDate,
                )?.toLocaleTimeString('pt-BR', {
                  hour: '2-digit',
                  minute: '2-digit',
                })}`
                : '--',
            },
            {
              id: `item-10`,
              value: each?.dueDate
                ? new Date(each?.dueDate)?.toLocaleDateString()
                : '--',
            },
          ];

          const columns = configuredColumns
            .filter((col) => col.show)
            .map((col) => {
              return tableCells.find((cell) => cell.id == col.id);
            });

          return (
            <TableRow key={each?.debtsCode}>
              <td
                style={{
                  padding: '0 0 0 16px',
                  minWidth: '0',
                  textAlign: 'left',
                }}
                className="check-column"
              >
                <CheckBoxInput
                  type="checkbox"
                  checked={isChecked[each.debtsCode]}
                  onChange={() =>
                    setIsChecked((prev: any) => ({
                      ...prev,
                      [String(each.debtsCode)]: !isChecked[each.debtsCode],
                    }))
                  }
                />
              </td>
              {columns.map((column) => (
                <CellsRow
                  content={column?.value}
                  style={column?.style}
                  className={column?.className}
                />
              ))}
            </TableRow>
          );
        })}
    </>
  );
}
